import { Box, Tooltip, Typography, IconButton } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

const truncate = (value, length = 12) =>
  value.length > length ? value.slice(0, length) + "…" : value;

export default function CopyableMono({ value, copy = true }) {
  if (!value) return null;

  return (
    <Box display="flex" alignItems="center">
      <Tooltip title={value}>
        <Typography sx={{ fontFamily: "monospace" }}>{truncate(value)}</Typography>
      </Tooltip>

      {copy && (
        <Tooltip title="Copy">
          <IconButton size="small" sx={{ ml: 1 }} onClick={() => navigator.clipboard.writeText(value)}>
            <ContentCopyIcon fontSize="inherit" />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
}
